module.exports = __webpack_public_path__ + "static/media/ic_categories_football.8a3263da.svg";